import { createAction, props } from '@ngrx/store';
export type ProductBOM = any;
export type PlantsWithBOMList = any;

export const loadPlantsWithBOMByProductList = createAction(
  '[PlantsWithBOMByProductList] Load',
  props<{ products: ProductBOM[] }>(),
);

export const loadPlantsWithBOMByProductListSuccess = createAction(
  '[PlantsWithBOMByProductList] Load Success',
  props<{ products: ProductBOM[]; result: PlantsWithBOMList[] }>(),
);

export const loadPlantsWithBOMByProductListFailure = createAction(
  '[PlantsWithBOMByProductList] Load Failure',
  props<{ products: ProductBOM[]; error: any }>(),
);

export const resetPlantsWithBOMByProductListState = createAction('[PlantsWithBOMByProductList] Reset State');
